import { render, staticRenderFns } from "./AAsignacionTabla1.vue?vue&type=template&id=caf1b716&scoped=true"
import script from "./AAsignacionTabla1.vue?vue&type=script&lang=js"
export * from "./AAsignacionTabla1.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionTabla1.vue?vue&type=style&index=0&id=caf1b716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf1b716",
  null
  
)

export default component.exports